// AUTO-GENERATED by scripts/gen-name-index.ts — do not edit by hand.
export interface ConsularCountryName { slug: string; nameTh: string; nameEn: string }
export const CONSULAR_COUNTRY_NAMES: ConsularCountryName[] = [
  {
    "slug": "usa",
    "nameTh": "สหรัฐอเมริกา",
    "nameEn": "United States"
  },
  {
    "slug": "united-kingdom",
    "nameTh": "สหราชอาณาจักร",
    "nameEn": "United Kingdom"
  },
  {
    "slug": "australia",
    "nameTh": "ออสเตรเลีย",
    "nameEn": "Australia"
  },
  {
    "slug": "new-zealand",
    "nameTh": "นิวซีแลนด์",
    "nameEn": "New Zealand"
  },
  {
    "slug": "canada",
    "nameTh": "แคนาดา",
    "nameEn": "Canada"
  },
  {
    "slug": "germany",
    "nameTh": "เยอรมนี",
    "nameEn": "Germany"
  },
  {
    "slug": "france",
    "nameTh": "ฝรั่งเศส",
    "nameEn": "France"
  },
  {
    "slug": "italy",
    "nameTh": "อิตาลี",
    "nameEn": "Italy"
  },
  {
    "slug": "spain",
    "nameTh": "สเปน",
    "nameEn": "Spain"
  },
  {
    "slug": "netherlands",
    "nameTh": "เนเธอร์แลนด์",
    "nameEn": "Netherlands"
  },
  {
    "slug": "switzerland",
    "nameTh": "สวิตเซอร์แลนด์",
    "nameEn": "Switzerland"
  },
  {
    "slug": "japan",
    "nameTh": "ญี่ปุ่น",
    "nameEn": "Japan"
  },
  {
    "slug": "china",
    "nameTh": "จีน",
    "nameEn": "China"
  },
  {
    "slug": "south-korea",
    "nameTh": "เกาหลีใต้",
    "nameEn": "South Korea"
  },
  {
    "slug": "india",
    "nameTh": "อินเดีย",
    "nameEn": "India"
  },
  {
    "slug": "uae",
    "nameTh": "สหรัฐอาหรับเอมิเรตส์",
    "nameEn": "United Arab Emirates"
  },
  {
    "slug": "saudi-arabia",
    "nameTh": "ซาอุดีอาระเบีย",
    "nameEn": "Saudi Arabia"
  },
  {
    "slug": "taiwan",
    "nameTh": "ไต้หวัน",
    "nameEn": "Taiwan"
  },
  {
    "slug": "vietnam",
    "nameTh": "เวียดนาม",
    "nameEn": "Vietnam"
  }
];
